import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Search from "../../../components/search";
import Imglist from "../component/imglist";
import Share from "../component/share";
// import Estate from "../component/estate";
import Nothing from "../../../components/nothing";
import Message from "../../../components/message";
import { getBestAnchorGivenScrollLocation } from '../utils/scroll';
import request from '../../../service/request';
import { CUSTOMER_FOCUS_POST, CUSTOMER_CANCELFOCUS_POST, POIFATHERTYPE_GET, ROUNDDETAIL_POST } from '../../../service/api';
import utils from '../../../utils';
import s from './index.less';

function Detail(props) {
    useStyles(s);

    const Viewer = typeof document !== 'undefined' && require('react-viewer').default;
    // const Amap = typeof window !== 'undefined' && require('../component/amap').default;
    const Estate = typeof window !== 'undefined' && require('../component/estate').default;
    const houseId = props.pagedata.id;
    const pageCode = props.pagedata.pageCode || 0;
    const { shopQr } = props.pagedata // 网店小程序码
    const infrastructureList = [
        { icon: '&#xe7a4;', text: '床' },
        { icon: '&#xe79e;', text: '桌椅' },
        { icon: '&#xe79b;', text: '衣柜' },
        { icon: '&#xe797;', text: '电视' },
        { icon: '&#xe7a1;', text: '冰箱' },
        { icon: '&#xe7a2;', text: '空调' },
        { icon: '&#xe7a3;', text: '热水器' },
        { icon: '&#xe796;', text: '独卫' },
        { icon: '&#xe798;', text: '宽带' },
        { icon: '&#xe7a0;', text: '暖气' },
        { icon: '&#xe79d;', text: '洗衣机' },
        { icon: '&#xe79c;', text: '天然气' },
        { icon: '&#xe79a;', text: '微波炉' },
        { icon: '&#xe799;', text: '燃气灶' },
        { icon: '&#xe79f;', text: '油烟机' }
    ];



    const [navList, setNavList] = useState({
        list: [
            { id: 'tab1', title: '房屋信息' },
            { id: 'tab2', title: '房源描述' },
            { id: 'tab3', title: '小区信息' }
        ],
        selectIndex: 'tab1',
        show: false
    });

    const [houseInfo, setHouseInfo] = useState(props.pagedata.houseInfo || {});
    const isVr = { // 判断是否是VR房源
        isVr: houseInfo.isVr,
        vrModelInfo: houseInfo.vrModelInfo
    }
    const viewerImgList = props.pagedata.viewerImgList ? utils.imgWatermark(props.pagedata.viewerImgList, 'src') : [];

    const [viewerImg, setViewerImg] = useState({
        modalIsOpen: false,
        selected: 0,
        list: []
    });

    const [qualifyUrlModelState, setQualifyModelState] = useState(false);
    const [qualifyUrl, setQualifyUrlState] = useState([]);

    const agent = props.pagedata.agent || {};

    const [messageInfo, setMessageInfo] = useState({
        visible: false,
        txt: ''
    });

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
    }, []);

    const handleScroll = () => {// 滚动呈现
        const bestAnchorId = getBestAnchorGivenScrollLocation(navList.list, -20);
        if (bestAnchorId && navList.selectIndex !== bestAnchorId) {
            setNavList({
                ...navList,
                show: true,
                selectIndex: bestAnchorId
            });
        } else {
            setNavList({
                ...navList,
                selectIndex: 'tab1',
                show: window.pageYOffset >= 800
            });
        }
    };

    const scrollToAnchor = (anchorName) => {// 锚点
        if (anchorName) {
            const anchorElement = document.getElementById(anchorName);// 找到锚点
            if (anchorElement) { anchorElement.scrollIntoView({ block: 'start', behavior: 'auto' }); }// 如果对应id的锚点存在，就跳转到锚点
        }
    };

    const shareTemplte = () => {
        return (
            typeof document !== 'undefined' ?
                <div className="page-share" onClick={focusHouse}>
                    <div className='button'>
                        {props.userInfo && houseInfo.isFocus ?
                            <><i className="iconfont icon-share">&#xe7a7;</i><font className="hover-hide">已关注</font><font className="hover-show">取消关注</font></>
                            :
                            <><i className="iconfont icon-share">&#xe7aa;</i>关注</>}
                    </div>
                    {/* <div className='button' style={{ marginLeft: '18px' }}>
                        <img src={require("../../../images/common/share.png")} />
                        分享
                    </div> */}
                </div>
                : null

        )
    };

    const showViewer = (index, list) => {
        setViewerImg({
            modalIsOpen: true,
            selected: index,
            list
        })
    };

    const changeModelState = (url) => {
        setQualifyUrlState([{ 'src': url }]);
        setQualifyModelState(true);
    };
    const closeModel = () => {
        setQualifyModelState(false);
    };

    const toggleModal = () => {
        setViewerImg({
            ...viewerImg,
            modalIsOpen: !viewerImg.modalIsOpen
        })
    };

    const imgError = (e, type) => {
        e.target.onerror = null;
        e.target.src = require(`../../../images/common/${type ? "agent-default.jpg" : "default-img.png"}`);
    };

    const roundDetail = async () => {
        const [roundFather, roundData] = await Promise.all([
            request.GET({
                url: POIFATHERTYPE_GET
            }),
            request.POST({
                url: ROUNDDETAIL_POST,
                params: { houseId, houseType: 2 }
            })
        ]);
        const data = {
            roundFather,
            roundData
        }
        return data;
    };

    const focusHouse = () => {
        if (props.userInfo) {
            request.POST({
                url: [CUSTOMER_FOCUS_POST, CUSTOMER_CANCELFOCUS_POST][houseInfo.isFocus ? 1 : 0],
                params: {
                    houseType: 2,
                    houseId
                }
            }).then(() => {
                setHouseInfo({
                    ...houseInfo,
                    isFocus: !houseInfo.isFocus
                });
                setMessageInfo({
                    visible: true,
                    txt: houseInfo.isFocus ? '房源取关成功' : '房源关注成功'
                });
            }).catch((error) => {
                console.log(error, 'error');
            });
        } else {
            const loginDiv = document.getElementsByClassName('mine-follow')[0];
            loginDiv.click();
        }
    }

    const closeMessage = () => {
        setMessageInfo({
            visible: false,
            txt: ''
        });
    };
    return (
        <>{pageCode === 0 ? (Object.keys(houseInfo).length > 0 ?
            <>
                <div className="page-detail">
                    <Search
                        businesstype={2}
                        isdetail
                        housename={houseInfo.houseName}
                        houseid={houseId} />

                    <div className="view-box clear">
                        <div className="header-title detail-head">
                            <h1>{houseInfo.houseName}</h1>
                            {/* <h3>房源编号：<span>{houseInfo.houseCode}</span></h3> */}
                            {
                                houseInfo.decorationStateF ? <>
                                    <p>
                                        <span>{houseInfo.decorationStateF}</span>
                                        {/* <span className="new">精装房源</span> */}
                                    </p>
                                </> : null
                            }

                            {props.userInfo ? shareTemplte() : null}
                        </div>

                        <Imglist imglist={houseInfo.roomImage || []} isVr={isVr || {}} />

                        <div className="detail-content">
                            <div className="header-price price">
                                <span className="total">{houseInfo.salePrice}</span>
                                <span className="unit">元/月{houseInfo.tradePaymentF ? `（${houseInfo.tradePaymentF}）` : null}</span>
                            </div>

                            <div className={houseInfo.orientation.length >= 3 ? "detail more" : "detail"}>
                                <div>
                                    <p>{houseInfo.room ? `${houseInfo.room}室` : ''}{houseInfo.parlor ? `${houseInfo.parlor}厅` : ''}</p>
                                    <p>户型</p>
                                </div>
                                <div>
                                    <p>{houseInfo.area}m²</p>
                                    <p>面积</p>
                                </div>
                                <div>
                                    <p>{houseInfo.orientation}</p>
                                    <p>朝向</p>
                                </div>
                                <div>
                                    <p>{houseInfo.storey ? houseInfo.storey : '暂无'}</p>
                                    <p>{houseInfo.totalFloor ? `共${houseInfo.totalFloor}层` : '楼层'}</p>
                                </div>
                            </div>

                            <div className="estate">
                                <div>
                                    <p><span>房源编号</span>{houseInfo.houseCode || '暂无数据'}</p>
                                    <p><span>装修情况</span>{houseInfo.decorationStateF || '暂无数据'}</p>
                                </div>
                                <div>
                                    <p><span>出租方式</span>{houseInfo.rentTypeF || '暂无数据'}</p>
                                    <p><span>入住时间</span>{houseInfo.rentTime || '暂无数据'}</p>
                                </div>
                                <div>
                                    <p><span>看房时间</span>{houseInfo.inspectTypeF || '暂无数据'}</p>
                                    <p><span>租期要求</span>{houseInfo.rentPeriodF || '暂无数据'}</p>
                                </div>
                            </div>
                            {Object.keys(agent).length ?
                                <div className="header-agent agent">
                                    <img className="header-img" onError={(e) => imgError(e, 'agent')} src={agent.onePhoto ? agent.onePhoto : (agent.src ? agent.src : require("../../../images/common/agent-default.jpg"))} />
                                    {agent.shopId ?
                                        <div className="xcx-code">
                                            <img src={shopQr && shopQr.qrCode} />
                                            <p>微信扫码进入经纪人网店</p>
                                            <p>享受专属购房服务</p>
                                        </div> : null}
                                    <div className="content">
                                        <div className="name-txt">
                                            <span>{agent.name}</span>
                                            <i>{agent.brand ? agent.brand : null}</i>
                                            {agent.certificationVO ?
                                                agent.certificationVO.certification ? <img onClick={() => changeModelState(agent.certificationVO.certification)} className="icon-img" src="http://static.hsdcyf.com/client/img/1726726617978.png" />
                                                    : null
                                                : null
                                            }
                                        </div>
                                        {agent.shopId ?
                                            <div className="xcx-codeN">
                                                <img src={shopQr && shopQr.qrCode} />
                                                <p>微信扫码进入经纪人网店</p>
                                                <p>享受专属购房服务</p>
                                            </div> : null}
                                        {agent.certificationVO ?
                                            agent.certificationVO.code ? <p className="agentArea"><span>执业编码：</span><span>{agent.certificationVO.code}</span></p>
                                                : null
                                            : null
                                        }
                                        {agent.shopName ? <p className="agentArea"><span>{agent.shopName}</span></p> : null}
                                        {agent.phone ? <p>手机号：<span>{agent.phone}</span></p> : null}
                                    </div>
                                </div> : null}
                        </div>
                    </div>

                    <div style={{ height: '92px', display: navList.show ? 'block' : 'none' }} />
                    <div className={navList.show ? "tab-box fixed" : 'tab-box'}>
                        <div className="list">
                            <ul>
                                {navList.list.map((items, index) => {
                                    return <li key={index} className={navList.selectIndex === items.id ? "active" : ''} onClick={() => scrollToAnchor(`tab${index + 1}`)}>{items.title}</li>
                                })}
                            </ul>
                            {navList.show && props.userInfo ? shareTemplte() : null}
                        </div>
                    </div>

                    <div className={navList.show && Number(navList.selectIndex.replace(/[^0-9]/ig, "")) < navList.list.length - 1 ? "detail-title-price-box fixed" : 'detail-title-price-box'}>
                        <div className="box">
                            <div className="header-title">
                                <h1>{houseInfo.houseName}</h1>
                            </div>
                            <div className="header-price">
                                <span className="total">{houseInfo.salePrice}</span>
                                <span className="unit">元/月{houseInfo.tradePaymentF ? `（${houseInfo.tradePaymentF}）` : null}</span>
                            </div>
                        </div>

                        {Object.keys(agent).length ?
                            <div className="header-agent clear">
                                <p className="title">房源经纪人</p>
                                <img className="header-img" onError={(e) => imgError(e, 'agent')} src={agent.onePhoto ? agent.onePhoto : (agent.src ? agent.src : require("../../../images/common/agent-default.jpg"))} />
                                {agent.shopId ?
                                    <div className="xcx-code">
                                        <img src={shopQr && shopQr.qrCode} />
                                        <p>微信扫码进入经纪人网店</p>
                                        <p>享受专属购房服务</p>
                                    </div> : null}
                                <div className="content">
                                    <div className="name-txt">
                                        <span>{agent.name}</span>
                                        <i>{agent.brand ? agent.brand : null}</i>
                                        {agent.certificationVO ?
                                            agent.certificationVO.certification ? <img onClick={() => changeModelState(agent.certificationVO.certification)} className="icon-img" src="http://static.hsdcyf.com/client/img/1726726617978.png" />
                                                : null
                                            : null
                                        }
                                    </div>
                                    {agent.shopId ?
                                        <div className="xcx-codeN">
                                            <img src={shopQr && shopQr.qrCode} />
                                            <p>微信扫码进入经纪人网店</p>
                                            <p>享受专属购房服务</p>
                                        </div> : null}
                                    {agent.certificationVO ?
                                        agent.certificationVO.code ? <p className="agentArea"><span>执业编码：</span><span>{agent.certificationVO.code}</span></p>
                                            : null
                                        : null
                                    }
                                    {agent.shopName ? <p className="agentArea"><span>{agent.shopName}</span></p> : null}
                                    {agent.phone ? <p>手机号：<span>{agent.phone}</span></p> : null}
                                </div>
                            </div> : null}
                    </div>

                    <div className="main-box">
                        <div id='tab1' className="base-content base">
                            <h2>房屋信息</h2>
                            {
                                houseInfo.roomInfo.decorationStateF ? <>
                                    <h4>
                                        <span>{houseInfo.roomInfo.decorationStateF}</span>
                                        {/* <span className="new">精装房源</span> */}
                                    </h4>
                                </> : null
                            }

                            <div className="main clear base">
                                <div className="name">基础属性</div>
                                <div className="content">
                                    <div>
                                        <p><span>面积</span>{houseInfo.roomInfo.area ? `${houseInfo.roomInfo.area}m²` : '暂无数据'}</p>
                                        <p><span>朝向</span>{houseInfo.roomInfo.orientation || '暂无数据'}</p>
                                    </div>
                                    <div>
                                        <p><span>维护</span>{houseInfo.roomInfo.maintenanceTime ?
                                            utils.timeFromNow(houseInfo.roomInfo.maintenanceTime, (new Date().toISOString()).slice(0, 10), 'day') : '暂无数据'}</p>
                                        <p><span>入住时间</span>{houseInfo.roomInfo.rentTime || '暂无数据'}</p>
                                    </div>
                                    <div>
                                        <p><span>楼层</span>{houseInfo.roomInfo.storey ? houseInfo.roomInfo.storey + (houseInfo.totalFloor ? `/共${houseInfo.totalFloor}层` : '') : '暂无'}</p>
                                        <p><span>租期要求</span>{houseInfo.roomInfo.rentPeriodF || '暂无数据'}</p>
                                    </div>
                                    <div>
                                        <p><span>车位</span>{houseInfo.roomInfo.carportTypeF || '暂无数据'}</p>
                                        <p><span>看房</span>{houseInfo.roomInfo.inspectTypeF || '暂无数据'}</p>
                                    </div>
                                    <div>
                                        <p><span>装修情况</span>{houseInfo.roomInfo.decorationStateF || '暂无数据'}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="main clear transaction">
                                <div className="name">配套设施</div>
                                <div className="content">
                                    <ul>
                                        {infrastructureList.map((item, index) => {
                                            return (<li key={index} className={houseInfo.roomInfo.infrastructure.indexOf(item.text) >= 0 ? 'oneline' : ''}>
                                                <i className="iconfont icon-top" dangerouslySetInnerHTML={{ __html: item.icon }} />{item.text}
                                            </li>)
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div id='tab2' className="base-content picture">
                            <h2>房源描述</h2>
                            <div className="main">
                                {Object.keys(agent).length ?
                                    <div className="header-agent">
                                        <img className="header-img" onError={(e) => imgError(e, 'agent')} src={agent.onePhoto ? agent.onePhoto : (agent.src ? agent.src : require("../../../images/common/agent-default.jpg"))} />
                                        <div className="content">
                                            <div className="name-txt">
                                                <span>{agent.name}</span>
                                                <i>{agent.brand ? agent.brand : null}</i>
                                                {agent.certificationVO ?
                                                    agent.certificationVO.certification ? <img onClick={() => changeModelState(agent.certificationVO.certification)} className="icon-img" src="http://static.hsdcyf.com/client/img/1726726617978.png" />
                                                        : null
                                                    : null
                                                }
                                            </div>
                                            <p className="agentArea"><span>{agent.shopName ? agent.shopName : null}</span></p>
                                        </div>
                                        {agent.phone ? <div className="phone"><i className="iconfont icon-phone">&#xe788;</i>电话咨询<span>{agent.phone}</span></div> : null}
                                    </div> : null}

                                {houseInfo.roomImage && houseInfo.roomImage.length ?
                                    <div className="pic-list">
                                        {houseInfo.roomImage && houseInfo.roomImage.length ? houseInfo.roomImage.map((item, index) => {
                                            return (<div key={index} onClick={() => showViewer(index, viewerImgList)}>
                                                <img onError={(e) => imgError(e)} src={`${item.src}?x-oss-process=style/acommon`} />
                                                {item.alt ? <span className="name">{item.alt}</span> : null}
                                            </div>
                                            )
                                        }) : null}
                                    </div> : <Nothing pagetype="detail" />}
                            </div>
                        </div>

                        {/* {Amap ? <Amap
                            index={navList.list.length}
                            title={navList.list[navList.list.length - 1].title}
                            businesstype={1}
                            datasouse={houseInfo.estateInfo}
                            latitude={houseInfo.latitude}
                            longitude={houseInfo.longitude}
                            mapname={houseInfo.houseName}
                            roundDetail={roundDetail}
                        /> : null} */}
                        {Estate ? <Estate
                            index={navList.list.length}
                            title={navList.list[navList.list.length - 1].title}
                            businesstype={2}
                            datasouse={houseInfo.estateInfo}
                            latitude={houseInfo.latitude}
                            longitude={houseInfo.longitude}
                            mapname={houseInfo.houseName} />
                            : null}
                    </div>
                </div>

                {/* <Share houseId={houseId} businesstype={2} /> */}
            </> : null) : <Nothing pagetype={pageCode} />}

            {Viewer ? <Viewer
                className="react-img"
                visible={viewerImg.modalIsOpen}
                onClose={toggleModal}
                activeIndex={viewerImg.selected}
                images={viewerImg.list}
                disableMouseZoom
                drag={false}
            /> : null}

            {qualifyUrlModelState ? <Viewer
                className="react-img"
                visible={qualifyUrlModelState}
                onClose={closeModel}
                activeIndex={0}
                images={qualifyUrl}
                disableMouseZoom
                drag={false}
            /> : null}

            <Message visible={messageInfo.visible} txt={messageInfo.txt} closeMessage={closeMessage} />
        </>
    );
}

const mapState = state => {
    return {
        userInfo: state.user.userInfo
    };
};

export default connect(mapState)(Detail);